export default "__VITE_ASSET__d1dac4a2__"